import { Layout } from 'antd';
import { SorterResult } from 'antd/es/table/interface';

import { TableWithForm } from 'components';

import { useGetHeaders, useMemoState, useTableSearchParams, useUserRole } from 'hooks';

import { Retailer } from 'codegen';

import { handleRetailersTableChange, retailerColumns } from '../../lib';

export const RetailersTab = () => {
  const [sortOrderInfo, setSortOrderInfo] = useMemoState<SorterResult<Retailer>>({ field: 'id', order: 'descend' });

  const headers = useGetHeaders();

  const { setSearchParams, defaultTableParams } = useTableSearchParams();

  const { isAdmin } = useUserRole();

  return (
    <Layout className='h-[85vh]'>
      <TableWithForm
        horizontalScroll
        id='retailers-table'
        columns={retailerColumns(isAdmin, sortOrderInfo)}
        onTableChange={handleRetailersTableChange(headers, setSearchParams, setSortOrderInfo)}
        defaultTableParams={defaultTableParams}
      />
    </Layout>
  );
};
